import React from 'react';
import { MapPin, Phone, ArrowRight, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-136">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-137">
        <img src="https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?auto=format&fit=crop&q=80&w=2000" alt="Beautiful California backyard pool" className="w-full h-full object-cover" data-id="element-138" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/70 to-transparent" data-id="element-139" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="max-w-2xl" data-id="element-141">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-500/20 border border-blue-400/30 backdrop-blur-md text-blue-200 text-sm font-medium mb-6" data-id="element-142">
            <MapPin className="w-4 h-4" data-id="element-143" />
            Serving Rocklin, Roseville & Greater Sacramento
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6 tracking-tight" data-id="element-144">
            Never Skim a Leaf Again. <br data-id="element-145" />
            <span className="text-blue-400" data-id="element-146">Crystal Clear Pool Days.</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg md:text-xl text-slate-300 mb-8 max-w-xl leading-relaxed" data-id="element-147">
            Get reliable, clockwork weekly pool maintenance from local experts.
            Enjoy your California oasis without lifting a finger.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-148">
            <button onClick={scrollToContact} className="bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-full font-bold text-lg transition-all flex items-center justify-center gap-2 shadow-lg shadow-blue-900/20 group" data-id="element-149">
              Get on the Route
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-150" />
            </button>
            <a href="tel:9169527728" className="bg-white/10 hover:bg-white/20 backdrop-blur-md text-white border border-white/20 px-8 py-4 rounded-full font-bold text-lg transition-all flex items-center justify-center gap-2" data-id="element-151">
              <Phone className="w-5 h-5" data-id="element-152" />
              (916) 952-7728
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="mt-10 flex flex-wrap gap-x-6 gap-y-2 text-sm text-slate-300 font-medium" data-id="element-153">
            <div className="flex items-center gap-1.5" data-id="element-154">
              <CheckCircle2 className="w-4 h-4 text-blue-400" data-id="element-155" /> Free Quotes
            </div>
            <div className="flex items-center gap-1.5" data-id="element-156">
              <CheckCircle2 className="w-4 h-4 text-blue-400" data-id="element-157" /> Flat Monthly
              Rates
            </div>
            <div className="flex items-center gap-1.5" data-id="element-158">
              <CheckCircle2 className="w-4 h-4 text-blue-400" data-id="element-159" /> Owner Operated
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}